import React from 'react';

function AdminEmployees() {

    return (
        <div>
 
            <div className="add-new-section">

                <form
                    id="admin-content-text-form"
                    className="admin-content-block">
                    
                    <p 
                        id="admin-sub-section-title"
                        className="cover-page-centered"
                        style={{ fontSize: '1.25rem' }}>
                        Add a new employee...
                    </p>
                    
                    <p>
                        <br/>

                        <input
                            className="new-admin-input"
                            id="new-admin-input"
                            onClick={() => { console.log('add first name of new employee') }}
                            placeholder="&nbsp;&nbsp;first name"
                        />

                        <input
                            className="new-admin-input"
                            id="new-admin-input"
                            onClick={() => { console.log('add last name of new employee') }}
                            placeholder="&nbsp;&nbsp;last name"
                        />

                        <input
                            className="new-admin-input"
                            id="new-admin-input"
                            onClick={() => { console.log('add the department of the new employee') }}
                            placeholder="&nbsp;&nbsp;department"
                        />

                        <input
                            className="new-admin-input"
                            id="new-admin-input"
                            onClick={() => { console.log('add the job title of the new employee') }}
                            placeholder="&nbsp;&nbsp;job title"
                        />

                        <input
                            className="new-admin-input"
                            id="new-admin-input"
                            onClick={() => { console.log('add the other category of the new employee') }}
                            placeholder="&nbsp;&nbsp;other catetory"
                        />

                        <button 
                            id="admin-button"
                            className="admin-button">
                            Add employee
                        </button>
                    
                    </p>
                
                </form>

                <p className="admin-menu-sub-separator"></p>

            </div>

            <div className="admin-list-section">

                <div 
                    id="admin-content-text"
                    className="admin-content-text">

                    <p 
                        id="admin-sub-section-title"
                        className="cover-page-centered"
                        style={{ marginBottom: '2rem', fontSize: '1.25rem' }}>
                        Current employees...
                    </p>

                    <div id="admin-employee-list-sequence-no">

                        {/* <!-- EMPLOYEES LIST HERE --> */}
                        
                        <p 
                            id="new-admin-input"
                            className="new-admin-input">
                            first_name
                        </p>

                        <p 
                            id="new-admin-input"
                            className="new-admin-input">
                            last_name
                        </p>

                        <p 
                            id="new-admin-input"
                            className="new-admin-input">
                            department
                        </p>

                        <p 
                            id="new-admin-input"
                            className="new-admin-input">
                            job_title
                        </p>

                        <p 
                            id="new-admin-input"
                            className="new-admin-input">
                            Other-Category
                        </p>

                        <button 
                            id="admin-button"
                            className="admin-button">
                            Edit employee
                        </button>

                        <p className="admin-section-sub-separator"></p>

                    </div>

                
                </div>

            </div>

        </div>
    );
}

export default AdminEmployees;